import { useRoutes } from "react-router-dom";
import { AuthProvider } from "@/app/providers/AuthProvider";
import { ToastProvider } from "@/app/providers/ToastProvider";
import { routes } from "@/app/routes";

function AppRoutes() {
  return useRoutes(routes);
}

/** 应用根：认证 + 提示 + 路由 */
export function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  );
}
